import React from "react";
export default function Prices() {
  return <section id="pricesheading" data-nav="light" className="bg-secondary text-secondary-foreground py-16 sm:py-20 md:py-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-3xl">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-primary animate-fade-in-up">
          Physiotherapy, Pelvic Health and Sports Massage Prices
        </h1>
        <p className="mt-4 sm:mt-6 font-sans text-base sm:text-lg lg:text-xl text-muted-foreground leading-relaxed animate-fade-in-up-delay-100">
          Clear pricing for physiotherapy, pelvic health and sports massage at our clinic in Warmsworth, Doncaster.
        </p>
      </div>
    </section>;
}